import Box from '@mui/material/Box';
import { FC, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useVideoCall } from '../../../contexts/videoCall/context';
import { getRoomUuidFromChannel } from '../../../lib/format';
import MixpanelClient, { TrackingEventV2 } from '../../../lib/tracking/mixpanel';
import '../../ChimeVideoCall/chime-video-call.css';
import EnaraMeeting from '../../ChimeVideoCall/components/EnaraMeeting';
import { MeetingInformation } from '../../ChimeVideoCall/meeting-call.types';
import CallEnded from './CallEnded';

type MainState = {
  meetingInfo: MeetingInformation | null;
  loadingJoin: boolean;
  callEnded: boolean;
};

const AppointmentVideoCall: FC = () => {
  const { videoCallState } = useVideoCall();

  const [mainState, setMainState] = useState<MainState>({
    meetingInfo: videoCallState.meetingInfo,
    loadingJoin: true,
    callEnded: false,
  });

  const leaveRoom = async (meetingId: string) => {
    const { videoPreview } = videoCallState;

    if (videoPreview && videoPreview.token) {
      const { token, appointment, source, eventsChannel, currentParticipant } = videoPreview;

      MixpanelClient.trackEvent({
        eventName: TrackingEventV2.VideoCallCloseMeeting,
        properties: {
          source,
          appointmentId: appointment.coreAppointmentId,
          waitingRoomUuid: getRoomUuidFromChannel(eventsChannel),
          participantUuid: currentParticipant.uuid,
        },
      });
    }

    setMainState((prevState) => ({
      ...prevState,
      room: null,
      loadingJoin: false,
      callEnded: true,
    }));
  };

  const { callEnded, meetingInfo, loadingJoin } = mainState;

  return (
    <Box className='app-chime'>
      <Helmet>
        <title>Enara: Join video call</title>
      </Helmet>

      <div>
        {callEnded ? (
          <CallEnded />
        ) : (
          <>{meetingInfo && <EnaraMeeting loadingMode={loadingJoin} onLeaveRoom={leaveRoom} />}</>
        )}
      </div>
    </Box>
  );
};

export default AppointmentVideoCall;
